import _classCallCheck from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/var/www/my-advo.cat/www/femida_web_client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
export var createMediaElementAudioSourceNodeConstructor = function createMediaElementAudioSourceNodeConstructor(audioNodeConstructor, createNativeMediaElementAudioSourceNode, getNativeContext, isNativeOfflineAudioContext) {
  return /*#__PURE__*/function (_audioNodeConstructor) {
    _inherits(MediaElementAudioSourceNode, _audioNodeConstructor);
    var _super = _createSuper(MediaElementAudioSourceNode);
    function MediaElementAudioSourceNode(context, options) {
      var _this;
      _classCallCheck(this, MediaElementAudioSourceNode);
      var nativeContext = getNativeContext(context);
      var nativeMediaElementAudioSourceNode = createNativeMediaElementAudioSourceNode(nativeContext, options);
      // Bug #171: Safari allows to create a MediaElementAudioSourceNode with an OfflineAudioContext.
      if (isNativeOfflineAudioContext(nativeContext)) {
        throw TypeError();
      }
      _this = _super.call(this, context, true, nativeMediaElementAudioSourceNode, null);
      _this._nativeMediaElementAudioSourceNode = nativeMediaElementAudioSourceNode;
      return _this;
    }
    _createClass(MediaElementAudioSourceNode, [{
      key: "mediaElement",
      get: function get() {
        return this._nativeMediaElementAudioSourceNode.mediaElement;
      }
    }]);
    return MediaElementAudioSourceNode;
  }(audioNodeConstructor);
};